/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M304.33 148.145c0-43.786 39.788-78.702 84.981-70.451 34.775 6.335 58.372 39.42 58.372 74.787v36.577c0 26.61-14.783 49.811-36.465 62.173-1.38.788-.929 2.787.676 2.787h26.215c40.266 0 73.21 32.945 73.21 73.21v74.563c0 .845-.675 1.549-1.548 1.549H360.11c.057-.62.339-1.155.339-1.802v-86.501c0-21.682-7.04-41.533-18.36-58.26-3.435-4.955-7.067-9.376-11.572-13.402-4.252-3.773-8.645-7.49-12.08-12.108-8.785-11.855-14.107-26.384-14.107-42.209zM74.859 107.172c0-50.797 46.15-91.316 98.58-81.77 40.408 7.377 67.777 45.756 67.777 86.81v42.462c0 30.862-17.148 57.809-42.321 72.141-1.633.901-1.098 3.238.76 3.238h30.439c46.742 0 84.98 38.239 84.98 84.98v86.502c0 .985-.816 1.802-1.802 1.802H2.802A1.815 1.815 0 011 401.535v-86.501c0-46.742 38.238-84.98 84.98-84.98h30.44c1.858 0 2.364-2.338.76-3.239-25.174-14.332-42.322-41.28-42.322-72.14z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconSupporters = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconSupporters.defaultProps = {
  theme,
};
IconSupporters.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconSupporters.displayName = 'IconSupporters';
export { IconSupporters };
